import { edgeServer, eduServer } from '../api_client/apiClient';
import { sortData } from '../util/utils';
import { GET_CHAPTERS_SUCCEEDED, GET_ASSIGNMENT_SUCCEEDED } from './Constants';

export function getWeeks(courseId) {
  return dispatch => {
    edgeServer.get(`console/courses/${courseId}/weeks`).then(res => {
      dispatch({
        type: 'SEARCH_WEEK_FULFILLED',
        payload: res.data.data.weeks
      });
    });
  };
}

// export function getDay(weekId, day) {
//   return (dispatch, getState) => {
//     edgeServer.get(`console/datasets/weeks/${weekId}/${day}`).then(res => {
//       let dailyData = sortData(res.data.data.data_sets);
//       dispatch({
//         type: 'SEARCH_DAY_FULFILLED',
//         payload: { data: dailyData, day: day, weekId: weekId }
//       });
//     });
//   };
// }

export function getChapters() {
  return dispatch => {
    edgeServer.get(`console/chapters`).then(res => {
      dispatch({
        type: GET_CHAPTERS_SUCCEEDED,
        payload: res.data.data.user_progress
      });
    });
  };
}

export function getAssignments(memberChapterId, category) {
  return dispatch => {
    eduServer
      .get(`client/contents/data/${memberChapterId}/${category}`)
      .then(res => {
        dispatch({
          type: GET_ASSIGNMENT_SUCCEEDED,
          payload: res.data.data
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/DashboardAction.js